import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface AccessRequestState {
  accessRequests: any[], 
  currentPatientId: any, 
  isRefreshAccessRequests: boolean, 
  initialRendering: boolean, 
  selectedAccessRequestId: string,
};

// ---------------

const initialState: AccessRequestState = {
  accessRequests: [], 
  currentPatientId: null, 
  isRefreshAccessRequests: false,      
  initialRendering: true, 
  selectedAccessRequestId: '', 
};

// ---------------

export const accessRequestsSlice = createSlice({

  name: 'accessRequests',

  initialState,

  reducers: {

    setAccessRequests: (state, action: PayloadAction<any>) => {

      state.accessRequests = action.payload; 

    },
    setCurrentPatientId: (state, action: PayloadAction<any>) => {

      state.currentPatientId = action.payload; 

    }, 
    setIsRefreshAccessRequests: (state, action: PayloadAction<boolean>) => {

        state.isRefreshAccessRequests = action.payload; 
  
    },
    setInitialRendering: (state, action: PayloadAction<boolean>) => {
  
      state.initialRendering = action.payload; 

    }, 
    setSelectedAccessRequestId: (state, action: PayloadAction<string>) => {
  
      state.selectedAccessRequestId = action.payload; 

    }, 
    resetAccessRequests: (state) => { 
        
        state.accessRequests = [];

        state.currentPatientId = null; 
        state.initialRendering = true; 

        state.selectedAccessRequestId = ''; 

        // Refreshers purposely omitted. 

    } 
  },

}); 

// ---------------

export const { 
    setAccessRequests, 
    setCurrentPatientId, 
    setIsRefreshAccessRequests, 
    setInitialRendering, 
    setSelectedAccessRequestId, 
    resetAccessRequests
 } = accessRequestsSlice.actions;

export default accessRequestsSlice.reducer;